<div class="register-page">
  <div class="register-card">
    <h1 class="register-card__title">Créer un compte</h1>
    <p class="register-card__subtitle">{{ stepLabels[currentStep] }} — étape {{ currentStep + 1 }}/{{ totalSteps }}</p>

    <div class="register-steps" aria-hidden="true">
      <span
        *ngFor="let label of stepLabels; let i = index"
        class="register-steps__dot"
        [class.register-steps__dot--active]="i === currentStep"
        [class.register-steps__dot--done]="i < currentStep"></span>
    </div>

    <form class="register-form" [formGroup]="form" (ngSubmit)="nextStep()" novalidate>
      <!-- Étape 0 : Informations personnelles -->
      <ng-container *ngIf="currentStep === 0">
        <div class="field-row">
          <div class="field-group field-group--half">
            <div class="field" [class.field--invalid]="form.controls.name.touched && form.controls.name.invalid">
              <input class="field__input" type="text" formControlName="name" placeholder="Nom(s)" />
            </div>
            <span class="field-error" *ngIf="form.controls.name.touched && form.controls.name.hasError('required')">Requis</span>
          </div>
          <div class="field-group field-group--half">
            <div class="field" [class.field--invalid]="form.controls.firstName.touched && form.controls.firstName.invalid">
              <input class="field__input" type="text" formControlName="firstName" placeholder="Prénom(s)" />
            </div>
            <span class="field-error" *ngIf="form.controls.firstName.touched && form.controls.firstName.invalid">Requis (2–50 car.)</span>
          </div>
        </div>

        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="lastName" placeholder="Postnom (optionnel)" />
          </div>
        </div>

        <div class="field-group">
          <div class="field" [class.field--invalid]="form.controls.email.touched && form.controls.email.invalid">
            <input class="field__input" type="email" formControlName="email" placeholder="E-mail" autocomplete="email" />
          </div>
          <span class="field-error" *ngIf="form.controls.email.touched && form.controls.email.invalid">E-mail invalide</span>
        </div>

        <div class="field-group">
          <app-phone-input
            #phoneInput
            formControlName="phone"
            inputId="register-phone"
            [invalid]="form.controls.phone.touched && form.controls.phone.invalid" />
          <span class="field-error" *ngIf="getPhoneError() as phoneError">{{ phoneError }}</span>
        </div>

        <div class="field-group">
          <div class="field" [class.field--invalid]="form.controls.address.touched && form.controls.address.invalid">
            <input class="field__input" type="text" formControlName="address" placeholder="Adresse" />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group field-group--half">
            <div class="field" [class.field--invalid]="form.controls.birthPlace.touched && form.controls.birthPlace.invalid">
              <input class="field__input" type="text" formControlName="birthPlace" placeholder="Lieu de naissance" />
            </div>
          </div>
          <div class="field-group field-group--half">
            <div class="field" [class.field--invalid]="form.controls.birthDate.touched && form.controls.birthDate.invalid">
              <input class="field__input" type="text" formControlName="birthDate" placeholder="Date naiss. JJ/MM/AAAA" />
            </div>
            <span class="field-error" *ngIf="form.controls.birthDate.touched && form.controls.birthDate.invalid">
              Date invalide (18 ans min.)
            </span>
          </div>
        </div>

        <div class="field-group">
          <div class="field" [class.field--invalid]="form.controls.niu.touched && form.controls.niu.invalid">
            <input class="field__input" type="text" formControlName="niu" placeholder="NIU (14 caractères)" maxlength="14" />
          </div>
          <span class="field-error" *ngIf="form.controls.niu.touched && form.controls.niu.invalid">NIU : 14 caractères alphanumériques</span>
        </div>
      </ng-container>

      <!-- Étape 1 : Mot de passe -->
      <ng-container *ngIf="currentStep === 1">
        <p class="register-hint">{{ passwordHint }}</p>

        <div class="field-group">
          <div class="field field--password" [class.field--invalid]="form.controls.password.touched && form.controls.password.invalid">
            <mat-icon class="field__icon" aria-hidden="true">lock</mat-icon>
            <input
              class="field__input"
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              placeholder="Mot de passe"
              autocomplete="new-password" />
            <button class="field__toggle" type="button" (click)="hidePassword = !hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="field-group">
          <div
            class="field field--password"
            [class.field--invalid]="form.controls.confirmPassword.touched && form.controls.confirmPassword.invalid">
            <mat-icon class="field__icon" aria-hidden="true">lock</mat-icon>
            <input
              class="field__input"
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirmPassword"
              placeholder="Confirmer le mot de passe"
              autocomplete="new-password" />
            <button class="field__toggle" type="button" (click)="hideConfirmPassword = !hideConfirmPassword">
              <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="form.controls.confirmPassword.touched && form.controls.confirmPassword.hasError('passwordMismatch')">
            Les mots de passe ne correspondent pas
          </span>
        </div>
      </ng-container>

      <!-- Étape 2 : Photo profil -->
      <ng-container *ngIf="currentStep === 2">
        <div class="upload-block">
          <div class="upload-preview" *ngIf="profilePhotoPreview; else noPhoto">
            <img [src]="profilePhotoPreview" alt="Aperçu photo de profil" />
          </div>
          <ng-template #noPhoto>
            <div class="upload-placeholder">
              <mat-icon>person</mat-icon>
              <span>Photo de profil</span>
            </div>
          </ng-template>
          <label class="upload-btn">
            Choisir une photo
            <input type="file" accept="image/*" hidden (change)="onProfilePhotoSelected($event)" />
          </label>
        </div>
      </ng-container>

      <!-- Étape 3 : Pièce d'identité -->
      <ng-container *ngIf="currentStep === 3">
        <div class="field-group">
          <div class="field">
            <select class="field__input field__select" formControlName="docType">
              <option *ngFor="let opt of identityDocOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
          </div>
        </div>

        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="docNumber" placeholder="Numéro de la pièce" />
          </div>
        </div>

        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="docExpiry" placeholder="Date expiration JJ/MM/AAAA" />
          </div>
        </div>

        <div class="upload-block upload-block--compact">
          <label class="upload-btn">
            {{ identityFileName || 'Joindre la pièce (PDF ou image)' }}
            <input type="file" accept="image/*,.pdf" hidden (change)="onIdentityFileSelected($event)" />
          </label>
        </div>
      </ng-container>

      <!-- Étape 4 : Coordonnées bancaires (optionnel) -->
      <ng-container *ngIf="currentStep === 4">
        <p class="register-hint">Cette étape est optionnelle. Vous pouvez continuer sans remplir ces champs.</p>

        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="bankAccount" placeholder="Numéro de compte" />
          </div>
        </div>
        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="bankName" placeholder="Nom de la banque" />
          </div>
        </div>
        <div class="field-group">
          <div class="field">
            <input class="field__input" type="text" formControlName="bankCode" placeholder="Code banque" />
          </div>
        </div>
      </ng-container>

      <!-- Étape 5 : OTP -->
      <ng-container *ngIf="currentStep === 5">
        <p class="register-hint">
          Un code à 6 chiffres a été envoyé au
          <strong>{{ otpPhoneDisplay }}</strong>.
        </p>

        <div class="field-group">
          <div class="field field--otp" [class.field--invalid]="form.controls.otp.touched && form.controls.otp.invalid">
            <input
              class="field__input field__input--otp"
              type="text"
              formControlName="otp"
              placeholder="000000"
              inputmode="numeric"
              maxlength="6"
              autocomplete="one-time-code" />
          </div>
        </div>

        <button
          class="register-link-btn"
          type="button"
          [disabled]="otpResendSeconds > 0 || loading"
          (click)="resendOtp()">
          {{ otpResendSeconds > 0 ? 'Renvoyer dans ' + otpResendSeconds + 's' : 'Renvoyer le code' }}
        </button>
      </ng-container>

      <p class="register-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
      <p class="register-success" *ngIf="successMessage" role="status">{{ successMessage }}</p>

      <div class="register-actions">
        <button class="register-btn register-btn--secondary" type="button" *ngIf="currentStep > 0 && currentStep < 5" (click)="previousStep()">
          Retour
        </button>
        <button class="register-btn register-btn--primary" type="submit" [disabled]="loading">
          {{
            loading
              ? 'Traitement…'
              : currentStep === 4
                ? 'Recevoir le code OTP'
                : currentStep === 5
                  ? 'Valider et créer le compte'
                  : 'Continuer'
          }}
        </button>
      </div>
    </form>

    <div class="register-login">
      <p>Déjà un compte ?</p>
      <a routerLink="/se-connecter">Se connecter</a>
    </div>
  </div>
</div>
